(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["giuama-slogan"] && !Shopify.designMode) return;
  try {
    (() => {
    const mobile = window.matchMedia('(max-width: 749px)');

    const fit = (el) => {
      if (mobile.matches && el.classList.contains('giuama-slogan--wrap-mobile')) {
        el.style.removeProperty('--giuama-fit-size');
        return;
      }
      const texts = el.querySelectorAll('.giuama-slogan__text');
      if (!texts.length) return;
      const target = el.clientWidth;
      if (!target) return;
      const probe = texts[0];
      probe.style.setProperty('--giuama-fit-size', '100px');
      const natural = probe.scrollWidth;
      if (!natural) return;
      const size = Math.max(11, (100 * target) / natural);
      el.style.setProperty('--giuama-fit-size', size.toFixed(2) + 'px');
      probe.style.removeProperty('--giuama-fit-size');
    };

    const fitAll = () => document.querySelectorAll('[data-giuama-fit]').forEach(fit);
    const observer = new ResizeObserver((entries) => entries.forEach((e) => fit(e.target)));
    const watch = () => document.querySelectorAll('[data-giuama-fit]').forEach((el) => observer.observe(el));

    const start = () => { watch(); fitAll(); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    if (document.fonts) document.fonts.ready.then(fitAll);

    // Theme-Editor: Blöcke werden ohne Seitenwechsel neu gerendert
    document.addEventListener('shopify:section:load', start);
    document.addEventListener('shopify:block:select', fitAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
